/* Keep ordinary product searches focused on names and item numbers. */
(() => {
  const decode = (query) => {
    const match = /^title:"((?:\\.|[^"\\])*)" OR variants\.sku:"((?:\\.|[^"\\])*)"$/.exec(query || '');
    return match && match[1] === match[2] ? match[1].replace(/\\([\\"])/g, '$1') : query;
  };
  document.querySelectorAll('form[role="search"] input[type="search"]').forEach((input) => { input.value = decode(input.value); });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches('form[role="search"]')) return;
    const input = form.querySelector('input[type="search"]');
    const term = input?.value.trim();
    if (!term) { event.preventDefault(); return; }
    const text = term.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const query = `title:"${text}" OR variants.sku:"${text}"`;
    const hidden = form.querySelector('[data-ps-product-query]') || document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'q'; hidden.value = query; hidden.dataset.psProductQuery = '';
    input.removeAttribute('name'); form.append(hidden);
    let type = form.querySelector('input[name="type"]');
    if (!type) { type = document.createElement('input'); type.type = 'hidden'; type.name = 'type'; form.append(type); }
    type.value = 'product';
  });
})();
